export const currenciesList: { [key: string]: string } = {
  EUR: 'EUR',
  USD: 'USD',
  GBP: 'GBP',
}
